import { getJson, pathSegment, postEmpty } from "../client";
import { RESUME_BASE } from "./base";

/** A person's data export. */

/** `resume_api::responses::ExportDownload`: a signed link to the zip. */
export interface ExportDownload {
    url: string;
    expires_at: string;
}

export type ExportStatus = "PENDING" | "BUILDING" | "READY" | "EXPIRED" | "FAILED";

/** One of the caller's data exports. `resume_api::responses::DataExport`. */
export interface DataExport {
    export_id: string;
    status: ExportStatus;
    requested_at: string;
    finished_at: string | null;
    expires_at: string | null;
    byte_size: number | null;
    sha256: string | null;
    failure: string | null;
    /** Given by the read of one export while it is ready. */
    download?: ExportDownload | null;
}

export interface DataExportList {
    exports: DataExport[];
}

/**
 * Asks for an export of everything held about the caller, built in the
 * background and emailed when ready. 409 while one is being made, and
 * for a day after one was.
 */
export function requestExport(): Promise<DataExport> {
    return postEmpty(`${RESUME_BASE}/exports`);
}

/** The caller's last twenty exports, the newest first. */
export function listExports(): Promise<DataExportList> {
    return getJson(`${RESUME_BASE}/exports`);
}

/** One export, with its five minute download link while it is ready. */
export async function getExport(exportId: string): Promise<DataExport> {
    return getJson(`${RESUME_BASE}/exports/${pathSegment(exportId)}`);
}
